// extracted by mini-css-extract-plugin
export var accordionWrapper = "h_C";
export var addTransition = "h_D";
export var content = "h_F";